export const heroku = "https://grsportsdfsbackend.azurewebsites.net/";
export const testlocal = "http://localhost:8080/";